import React from "react";
import ReactDOM from "react-dom";
import { HashRouter as Router } from "react-router-dom";
import { Layout } from "pages/Layout";
import routes from "Routes";
import "bootstrap/dist/css/bootstrap.min.css";
import 'moment/locale/ja'; // プロジェクト全体で使用したいためここでimportしている

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <Layout>{routes}</Layout>
        </Router>
    </React.StrictMode>,
    document.getElementById(`root`)
);
